<template>
    <div>
            <div class="gandalf">
                <div class="fireball"></div>
                <div class="skirt"></div>
                <div class="sleeves"></div>
                <div class="shoulders">
                    <div class="hand left"></div>
                    <div class="hand right"></div>
                </div>
                <div class="head">
                    <div class="hair"></div>
                    <div class="beard"></div>
                </div>
            </div>
            <div class="message">
                <h1>You Shall Not Pass</h1>
                <p>Uh oh, Gandalf is blocking the way!<br />Maybe you have a typo in the url? Or you meant to go to a different location?</p>
            </div>
    </div>
</template>

<script>
    export default {
        name: 'Unauthorized',
    }
</script>
